import { Component, OnInit } from '@angular/core';
import { KeyValue } from '../key-value';
import {AuthorizationService} from '../authorization.service';
import { AngularTokenService } from '@lakshvairav/angular-token';
declare function init_dropdown(): void;
@Component({
  selector: 'report-menu',
  templateUrl: 'report-menu.component.html'
})

export class ReportMenuComponent implements OnInit {
  qtrs = [];
  bank_reports = [];
  ins_reports = [];
  dec_reports = [];
  communities = [];
  teams = [];
  instr_reports = [];
  c_reports = [];
  com_reports = [];
  c_arr = [];
  ins_arr = [];
  role: string = '';
  count_t: any;
  crep = [];
  b_r = [];
  cr = [];
  br = [];
  c_r = [];
  b_reports = [];
  token: any;

  constructor(private KeyValueService: KeyValue, public authService: AuthorizationService,
    private _tokenService: AngularTokenService) {
  }

  ngOnInit() {
    this.token = localStorage.getItem('accessToken');
    let that = this;
    // this.role = this._tokenService.currentUserData.nickname.toLowerCase()
    this.role = this.authService.getCRole().toLowerCase()
    this.authService.setBankDetails()
    KeyValue.report_menu.subscribe(
      data => {
        this.qtrs = [];
        localStorage.setItem('r_data', JSON.stringify(data));
        this.b_reports = data.report_nav.b_reports
        that.constructReportMenu(data)
        setTimeout(function(){
          init_dropdown();
        }, 1000);
      }
    )
  }

  // on session chage output report links are updated
  constructReportMenu(data): void {
    if (data.report_nav != undefined && data.report_nav.reports.length!=0 ) {
      // console.log('inside not defined');
      this.initialize_report_variables()
      for(let rep of data.report_nav.reports) {
        this.bank_reports.push(rep.bank)
        this.ins_reports.push(rep.ins)
        this.dec_reports.push(rep.dec)
      }
      this.qtrs = data.report_nav.qtrs;
      this.communities = data.report_nav.communities
      this.teams = data.report_nav.teams
      this.count_t = this.teams.length-1
      this.set_report()
      this.set_bank_report()
    }
  }

  construct_quarter_name(q_name) {
    return q_name.replace('Quater', 'Quarter');
  }

  set_report(){
    this.com_reports =["C91-Bank Balance Sheets", "C92-Income Statements", "C93-Community Loan and Deposit Markets",
    "C94-Community Bank Capital Activity", "C94A-Capital Ratio Requirements", "C95-Economic Charts", "C96-Economic Reporter", "I98-Risk and Stock Price Analysis"]
    for (let i=0; i<this.ins_reports.length; i++){
      this.instr_reports = []
      this.c_reports = []
      for(let ins of this.ins_reports[i]) {
        if(this.com_reports.includes(ins)){
          this.instr_reports.push(ins)
        }
        else{
        this.c_reports.push(ins)
        }
      }
      this.ins_arr.push(this.instr_reports)
      this.c_arr.push(this.c_reports)
    }
  }

  set_bank_report(){
    this.crep = ["C91-Bank Balance Sheets", "C92-Income Statements", "C93-Community Loan and Deposit Markets",
    "C94-Community Bank Capital Activity", "C94A-Capital Ratio Requirements", "C95-Economic Charts", "C96-Economic Reporter"]
    for (let i=0; i<this.bank_reports.length; i++){
      this.br = []
      this.cr = []
      for(let ban_k of this.bank_reports[i]) {
        if(this.crep.includes(ban_k)){
          this.br.push(ban_k)
        }
        else{
          this.cr.push(ban_k)
        }
      }
      this.b_r.push(this.cr)
      this.c_r.push(this.br)
    }
  }
  initialize_report_variables(){
    this.bank_reports = []
    this.ins_reports = []
    this.dec_reports = []
    this.ins_arr = []
    this.c_arr = []
    this.b_r = []
    this.c_r = []
  }

}
